// extracted by mini-css-extract-plugin
export default {"container":"YZ-z","title":"ZZ-z","link":"_Z-z"};